import { SET_TIMEZONES } from "./timezones.actionTypes";

const initialState = {
  timezones: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TIMEZONES: {
      return {
        ...state,
        timezones: action.payload,
      };
    }

    default:
      return state;
  }
};
